
export const getList = state => state.list;
export const load = state => state.load;
export const dialog = state => state.dialog;
export const successStatus = state => state.successStatus;
export const errorStatus = state => state.errorStatus;
export const sendReceiptResponse = state => state.sendReceiptResponse;
export const errorMessage = state => state.errorMessage;
export const id = state => state.id;
export const loadFile = state => state.loadFile;
export const fileConverted = state => state.fileConverted;

// Filtros
export const filtersInitialDate = state => state.filtersInitialDate;
export const filtersFinalDate = state => state.filtersFinalDate;
export const filtersStatus = state => state.filtersStatus;
export const filtersReason = state => state.filtersReason;
export const filtersAmount = state => state.filtersAmount;
export const filtersOrdination = state => state.filtersOrdination;
export const showFilters = state => state.showFilters;
export const currentPage = state => state.currentPage;
export const limit = state => state.limit;

export const chargebacksFilter = state => {
  const filters = {
    page: state.currentPage || 1,
    limit: state.limit || 25,
    filterrific: {
      with_created_at_between: {
        start_at: state.filtersInitialDate,
        end_at: state.filtersFinalDate
      },
      with_status: state.filtersStatus,
      with_reason: state.filtersReason,
      with_amount: state.filtersAmount,
      sorted_by: state.filtersOrdination
    }
  };
  return filters;
};
